const INITIAL_LOG = [
    {
        type: "text",
        heading: "Welcome",
        value: "This is an idle click time-waster where you claim land, build advancements on it, and find new combinations which unlock other advancements."
    },
    {
        type: "text",
        heading: "Land Points",
        value: "To claim land you have access to Land Points (LP). Building advancements on unexploited land gives you LP with which to claim new land. The more land you cover with advancements, the more new land you can claim."
    },
    {
        type: "text",
        heading: "Advancement Points",
        value: "You build advancements with Advancement Points (AP). AP regenerates automatically up to a maximum determined by how much unexploited land you have. As you claim more unexploited land, the maximum value your AP can reach will increase."
    },
    {
        type: "text",
        heading: "Combining",
        value: "When you build two (or more) advancements next to each other you may unlock new possible advancements. Some advancements are upgrades to existing advancements. Each time you use a particular advancement for the first time, AP regeneration speed increases slightly."
    }
];

const makeLogbook = () => {
    const log = [...INITIAL_LOG];

    return {
        getEntries: () => [...log],

        addDiscovery: (ancestorResourceOrAdvancement, descendantAdvancement) => {
            log.push({
                type: "discovery",
                ancestor: ancestorResourceOrAdvancement,
                descendant: descendantAdvancement
            });

            for (let entry of log) {
                if (entry.type === "hint" && entry.resultAdvancement.id === descendantAdvancement.id) {
                    entry.discovered = true;
                }
            }
        },

        addHint: (requirementAdvancements, resultAdvancement) => {
            log.push({
                type: "hint",
                requirementAdvancements: requirementAdvancements,
                resultAdvancement: resultAdvancement
            });
        }
    };
};

export default makeLogbook;